import { render, staticRenderFns } from "./widgetSuggestion.vue?vue&type=template&id=42f6257a&scoped=true&"
import script from "./widgetSuggestion.vue?vue&type=script&lang=js&"
export * from "./widgetSuggestion.vue?vue&type=script&lang=js&"
import style0 from "./widgetSuggestion.vue?vue&type=style&index=0&id=42f6257a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42f6257a",
  null
  
)

export default component.exports